import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ServiceAction, AdminUserAction, RayCodeAction, CalendarAction, CompanyAction, ErrorCodeAction, AlertAction } from '../../actions';
import { ServiceModalAction } from '../../actions/ServiceModalAction';
import { RayStatuses } from '../../config/RayCodes';
import { SERVICE_STATUS } from '../../config/ServiceConstants';
import {
	InputBasicText,
	InputBasicSelect,
	InputBasicTextArea,
	InputBasicDateTime,
	InputCombo,
	InputSelect2,
	InputSelect2Search,
} from "../../components/common/Inputs";
import { EditSaveCancelBar } from '../common/Buttons';
import { Translate as t } from '../../config/Translate';
import Loader from 'react-loader-spinner';
import { normalizeErrorCode } from '../../lib/serviceErrorCode';

export const ServiceInfoView = ({ su, service, UpdateService, UpdateStatus, UpdateAssignee, UpdatePriority, NotifyError, editable, callBackUpdate, onEdit, onCancel, clist, userAdminType, errorCodes, ErrorCodeList }) => {
	const [isAdmin, setIsAdmin] = useState(location.pathname.toLowerCase().startsWith('/admin/'));
	const userInfo = JSON.parse(localStorage.getItem("user"));
	const userCompanyId = userInfo.companyId;
	// IMP-283 M2: adminType 게이트 소스를 Redux AuthReducer.user 로 통일 (localStorage 직접 참조 제거).
	// userAdminType이 undefined 이면 undefined !== 'U' = true(허용) — AdminServiceList 동작과 동일.
	const isAdminUser = userAdminType !== 'U';
	// IMP-283: UX 게이트 — 서비스 상태 변경은 adminType 'U' 차단. 최종 권한 강제는 BE(service.statusUpdate/Bulk → ES0403).
	const [comboPending, setComboPending] = useState([]);
	const [status, setStatus] = useState(service.status);
	const [priority, setPriority] = useState(service.priority || '');
	const [assignee, setAssignee] = useState(service.assignee);
	const [data, setData] = useState({});
	const [prestatus, setPrestatus] = useState("");
	const [errorCodeList, setErrorCodeList] = useState([]);
	const [ownerShipList, setOwnerShipList] = useState([]);
	const [request, setRequest] = useState(false);

	const PriorityList = [
		{ code: '', title: '-' },
		{ code: 'URGENT', title: '🔴 ' + t('common.status.urgent') },
		{ code: 'FAVORITE', title: '⭐ ' + t('common.status.favorite') },
		{ code: 'NORMAL', title: '🟢 ' + t('common.status.normal') },
	];

	// 입력 state 를 마지막 서버 값(service)으로 맞춘다. 초기 동기화(effect)와 [취소]가 같이 쓴다.
	// remoteOwner 는 서버 값이 아닌 화면 선택값이라 effect 에서는 기존 선택을 유지하고, 취소에서만 되돌린다.
	const syncFromService = (resetOwner = false) => {
		setData({
			ticketKey: service.ticketKey,
			summary: service.summary,
			effectiveDate: service.effectiveDate,
			pendingReason: service.pendingReason,
			visitDate: service.visitDate || new Date().getTime(),
			remoteDate: service.remoteDate || new Date().getTime(),
			description: service.description,
			remoteOwner: (resetOwner ? service.remoteOwner : data.remoteOwner) || userCompanyId,
			remoteStatus: service.remoteStatus,
			errorCode: service.errorCode,
		});
		setPrestatus(service.status);
		setStatus(service.status);
		setPriority(service.priority || '');
		setAssignee(service.assignee);
	}

	const cancelEdit = () => {
		syncFromService(true);
		onCancel && onCancel();
	}

	useEffect(() => {
		syncFromService();
		// BUG-132: 정상 해제는 updateData finally 가 담당. 여기는 외부 service prop 갱신 시 재진입 방어용 백업 해제.
		if(request){
			setRequest(false);
		}
	}, [service])

	useEffect(() => {
		ErrorCodeList && ErrorCodeList();
	}, []);

	useEffect(() => {
		const result = [];
		errorCodes?.forEach(item => {
			if (item.model?.includes(service?.model) && item.lang == 'eng')
				result.push({ code: item.errorCode, title: item.errorCode });
		});
		result.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }));
		setErrorCodeList([{ code: '-', title: 'None' }, ...result]);
	}, [errorCodes, service?.model]);

	useEffect(() => {
		// RayCodeAction.GetAllByFilter({ type: "SERVICEPENDING" }).then(x => {
		// 	var list = [];
		// 	x.map(m => list.push({ code: m.code, title: m.name }));
		// 	setComboPending(list);
		// });
		const codes = Array.isArray(clist) ? clist : []; // BUG-157: 비배열 가드
		console.log('ServiceInfoView-SERVICEPENDING', codes.filter(x => x.type === 'SERVICEPENDING'));
		const x = codes.filter(x => x.type === 'SERVICEPENDING');
		const list = [];
		x.map(m => list.push({ code: m.code, title: m.name }));
		setComboPending(list);
		if (ownerShipList.length == 0)
			setOwner();
	}, [clist])

	const setOwner = async () => {
		// var list = await CompanyAction.GetParents();
		const list = await CompanyAction.GetParentsForRT();

		if (list.filter(x => x.code == "RAY00001").length == 0)
			list.push({ code: "RAY00001", title: "[HQ] RAY_HQ" });

		setOwnerShipList(list);
	}

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		if (name == "status") {
			setStatus(value);
		} else if (name == "assignee") {
			setAssignee(value);
		} else if (name == 'errorCode') {
			setData({ ...data, [name]: normalizeErrorCode(value) });
		} else {
			setData({ ...data, [name]: value });
		}
	}

	const getStatusExtra = (upData) => {
		if (status == SERVICE_STATUS.REMOTE) {
			upData["remoteOwner"] = upData.remoteOwner || data.remoteOwner;
			upData["remoteDate"] = upData.remoteDate || data.remoteDate;
			upData["remoteStatus"] = upData.remoteStatus || data.remoteStatus;
		} else if (status == SERVICE_STATUS.VISIT) {
			upData["visitDate"] = upData.visitDate || data.visitDate;
		}
		return upData;
	}

	const updateData = async () => {
		// BUG-225 (#443): 상세 조회 실패로 service 가 비어 있으면(_id 부재) 저장이
		// POST /service/undefined 로 나가 "Update Failed" 만 남는다(BUG-224 러시아 사례
		// 트리거) — 저장 시도 자체를 차단하고 데이터 미로드를 안내한다.
		if (!service?._id) {
			// 리뷰 M1: 차단 가드는 toast + console.warn (CLAUDE.md §7 FE 패턴)
			// 리뷰 F-010: caller/target identity 포함 (마스킹 원칙상 id 만)
			console.warn('[ServiceInfoView.updateData] blocked', {
				handler: 'ServiceInfoView.updateData',
				callerAdminId: userInfo?.adminid,
				callerCompanyId: userCompanyId,
				serviceId: service?._id,
				ticketKey: service?.ticketKey,
				reason: 'service._id 부재 — 상세 미로드 상태의 저장 시도 차단 (BUG-225)',
			});
			if (NotifyError) {
				NotifyError(t('service.message.loadFailed'));
			} else {
				// 리뷰 F-011: NotifyError 미주입 시 무음 차단 퇴행 방지 — 생략 사실을 관측 가능하게 남긴다
				console.warn('[ServiceInfoView] NotifyError 미주입 — 사용자 안내 생략', { reason: 'service._id 부재 차단 토스트(loadFailed) 미표시 (BUG-225)' });
			}
			return;
		}
		setRequest(true);
		const tasks = [];
		let saved = false;
		try {
			let upData = {};
			Object.keys(data).forEach(function (key) {
				if (data[key] != service[key])
					upData[key] = data[key];
			})

			if (status != service.status) {
				if (status == SERVICE_STATUS.REMOTE || status == SERVICE_STATUS.VISIT) {
					upData = getStatusExtra(upData, status);
					const schData = await regSchedule(upData, status);
					if (schData?.data?._id) {
						upData["scheId"] = schData.data._id;
					}
				}
				if (status == SERVICE_STATUS.REMOTE)
					upData["remoteStatus"] = "REMOTE_REQUEST";

				tasks.push(UpdateStatus(service._id, { status: status, extra: upData }));
				delete upData.scheId;
			} else if (status == SERVICE_STATUS.REMOTE) {
				const extra = getStatusExtra(upData);
				if (Object.keys(upData).length > 0) {
					tasks.push(UpdateStatus(service._id, { status: status, extra: extra }));
					delete upData.remoteDate;
					delete upData.remoteOwner;
				}
			} else if (status == SERVICE_STATUS.VISIT) {
				const extra = getStatusExtra(upData);
				if (Object.keys(upData).length > 0) {
					tasks.push(UpdateStatus(service._id, { status: status, extra: extra }));
					delete upData.visitDate;
				}
			}

			if (assignee != service.assignee)
				tasks.push(UpdateAssignee(service._id, { assignee: assignee }));

			if (Object.keys(upData).length > 0) {
				const updateData = {};
				Object.keys(upData).forEach(function (key) {
					if (key != "remoteOwner" && key != "scheId" && key != "remoteDate" && key != "visitDate" && key != "remoteStatus")
						updateData[key] = upData[key];
				})
				if (Object.keys(updateData).length > 0)
					tasks.push(UpdateService(service._id, updateData));
			}

			// 액션이 실패해도 reject 하지 않고 false 를 돌려주므로 결과로 판정한다
			const results = await Promise.all(tasks);
			saved = results.every((r) => r === true);
		} catch (e) {
			console.warn('[ServiceInfoView.updateData] update failed', { serviceId: service?._id, error: e?.message, reason: 'UpdateStatus/UpdateAssignee/UpdateService 또는 regSchedule 중 하나 이상 reject — 로딩은 finally 에서 해제' });
		} finally {
			setRequest(false);
			saved && callBackUpdate && callBackUpdate();
		}
	}

	const regSchedule = async (upData, type) => {
		return await CalendarAction.CreateUpdateByService({
			scheId: service.scheId || "",
			serviceId: service._id,
			color: type == "Remote" ? "bg-purple" : "bg-cyan",
			finish: type == "Remote" ?
				((upData.remoteDate || service.remoteDate) + 1000 * 60 * 60) :
				((upData.visitDate || service.visitDate) + 1000 * 60 * 60),
			model: service.model,
			option: service.option,
			siteId: service.sid,
			sitename: service.sitename,
			sn: service.sn,
			start: type == "Remote" ?
				(upData.remoteDate || service.remoteDate) :
				(upData.visitDate || service.visitDate),
			type: type
		});
	}

	const RemoteStatus = [
		{ code: "REMOTE_REQUEST", title: t('common.status.requested') },
		{ code: "REMOTE_ACCEPT", title: t('common.status.accepted') },
		{ code: "REMOTE_FINISH", title: t('common.status.finished') }
	]

	return (
		<div className="rayform section">
			<div className="card">
				<div className="card-body">

					{!editable && <InputBasicText
						options={{
							type: 'input',
							name: 'ticketKey',
							label: t('service.field.ticketNumber'),
							size: 12,
							val: data.ticketKey,
							required: true
						}}
						editable={false} />}

					{editable
						? <InputSelect2Search
							options={{
								type: "select2",
								name: "errorCode",
								label: t('product.field.errorCode'),
								list: errorCodeList,
								val: data.errorCode || '-',
							}}
							editable={true}
							onchange={handleChangeData} />
						: <InputBasicText
							options={{
								type: 'input',
								name: 'errorCode',
								label: t('product.field.errorCode'),
								size: 12,
								val: data.errorCode,
							}}
							editable={false} />}

					{editable && <InputBasicText
						options={{
							type: 'input',
							name: 'summary',
							label: t('common.field.subject'),
							size: 12,
							val: data.summary,
							required: true
						}}
						onchange={handleChangeData}
						editable={editable} />}

					<InputBasicSelect
						options={{
							type: "select",
							name: "status",
							label: t('common.label.status'),
							val: status,
							list: editable ? (su ? RayStatuses : RayStatuses.filter(x => x.code != SERVICE_STATUS.ESCALATE)) : RayStatuses,
							action: UpdateStatus
						}}
						onchange={handleChangeData}
						editable={editable && isAdminUser} />

					<InputBasicSelect
						options={{
							type: "select",
							name: "priority",
							label: t('service.field.priority'),
							val: priority,
							list: PriorityList,
						}}
						onchange={(e) => {
							const newPriority = e.target.value;
							setPriority(newPriority);
							UpdatePriority(service._id, newPriority, userInfo.adminid);
						}}
						editable={editable && isAdmin} />

					{status == "Monitoring" && <InputBasicSelect
						options={{
							type: "select",
							name: "pendingReason",
							label: t('service.field.monitoringReason'),
							val: data.pendingReason,
							list: comboPending
						}}
						onchange={handleChangeData}
						editable={editable} />}

					{/* IMP-407: remote/visit 계열은 status 상태머신 소속이라 저장 시 UpdateStatus 로 전송된다.
					    'U' 는 BE statusUpdate 가 차단(IMP-283)하므로 status 드롭다운과 동일 게이트를 적용해
					    편집 자체를 막는다(값은 읽기 전용으로 계속 노출). */}
					{status == SERVICE_STATUS.VISIT && <InputBasicDateTime
						options={{
							type: "datetime",
							name: "visitDate",
							label: t('service.field.visitDate'),
							val: data.visitDate,
						}}
						editable={editable && isAdminUser}
						onchange={handleChangeData} />}

					{status == SERVICE_STATUS.REMOTE && <InputBasicDateTime
						options={{
							type: "datetime",
							name: "remoteDate",
							label: t('service.field.remoteDate'),
							val: data.remoteDate,
						}}
						editable={editable && isAdminUser}
						onchange={handleChangeData} />}

					{status == SERVICE_STATUS.REMOTE &&
						<>
							{(isAdmin && editable && isAdminUser) &&
								<>
									<InputSelect2
										options={{
											type: "select",
											name: "remoteStatus",
											label: t('service.field.remoteStatus'),
											val: data.remoteStatus,
											list: RemoteStatus
										}}
										onchange={handleChangeData}
										editable={editable && isAdminUser} />
								</>}
							{/* IMP-407(PR #524): 읽기전용 분기는 편집분기(isAdmin && editable && isAdminUser)의
							    정확한 여집합이어야 remoteStatus 가 어느 조합에서도 소실되지 않는다. !isAdmin 을 포함해
							    비-admin 편집모드(예: /Service/:key)에서도 값이 읽기전용으로 노출되도록 망라화한다. */}
							{(!isAdmin || !editable || !isAdminUser) && <InputBasicSelect
								options={{
									type: "select",
									name: 'remoteStatus',
									label: 'Remote Status',
									val: data.remoteStatus,
									list: RemoteStatus,
								}}
								editable={false} />}
						</>}

					{status == SERVICE_STATUS.REMOTE && <InputSelect2
						options={{
							type: "select2",
							name: "remoteOwner",
							label: t('common.label.owner'),
							placeholder: t('common.label.owner'),
							list: ownerShipList,
							val: data.remoteOwner || userCompanyId
						}}
						editable={editable && isAdminUser}
						onchange={handleChangeData} />}

					{(data.effectiveDate > 0 || editable) && <InputBasicDateTime
						options={{
							type: "datetime",
							name: "effectiveDate",
							label: t('common.field.effectiveDate'),
							val: data.effectiveDate
						}}
						editable={editable}
						onchange={handleChangeData} />}

					<InputCombo
						options={{
							type: "combo",
							name: "assignee",
							label: t('common.label.assignee'),
							val: assignee,
							startval: t('common.status.unassigned'),
							action: UpdateAssignee,
							viewLinkPath: "/UserInfo/",
							getCombo: async () => {
								if (!service?.companyId) {
									console.warn('[ServiceInfoView] Assigned getCombo 중단 — service.companyId 부재로 빈 목록 반환', { ticketKey: service?.ticketKey });
									return [];
								}
								const users = await ServiceModalAction.GetAssigneeAvailabilityList(service?.companyId);
								return (users || []).map(u => ({
									code: u.adminid,
									title: `${u.availability === 'AVAILABLE' ? '🟢 ' : '⚫ '}${u.name || u.adminid}${u.availability !== 'AVAILABLE' ? ` (${t('service.issueManager.offDuty')})` : ''}`,
								}));
							}
						}}
						onchange={handleChangeData}
						editable={editable} />

					<InputBasicTextArea
						options={{
							type: 'textarea',
							name: 'description',
							label: t('common.field.description'),
							val: data.description,
						}}
						editable={editable}
						onchange={handleChangeData} />
					<div className="mt-2">
						<EditSaveCancelBar
							editing={!!editable}
							onEdit={onEdit}
							onSave={() => updateData()}
							onCancel={cancelEdit}
							saving={request}
							canEdit={!!onEdit || !!editable}
							saveLabelKey="common.button.update" />
						{request && <Loader
							type='ThreeDots'
							color='#2121db'
							width={30}
							height={30}
							visible={true}
							radius={10}
							style={{ display: 'inline-block', marginLeft: '10px', verticalAlign: 'middle' }} />}
					</div>
				</div>
			</div>
		</div>
	)
};

const mapState = (state) => {
	const service = state.ServiceReducer.service;
	const su = state.AuthReducer.su;
	const clist = state.RayCodeReducer.items;
	// IMP-283 M2: adminType 게이트 SSoT 통일 — localStorage 대신 Redux AuthReducer.user 에서 취득.
	const userAdminType = state.AuthReducer.user?.adminType;
	const errorCodes = state.ErrorCodeReducer.errorCodes;
	return { service, su, clist, userAdminType, errorCodes };
};

const mapDispatch = (dispatch) => ({
	UpdateStatus: (_id, data) => dispatch(ServiceAction.UpdateStatus(_id, data)),
	UpdateAssignee: (_id, data) => dispatch(ServiceAction.UpdateAssignee(_id, data)),
	UpdateServiceInfo: (_id, data) => dispatch(ServiceAction.UpdateService(_id, data)),
	UpdateService: (_id, data) => dispatch(ServiceAction.UpdateService(_id, data)),
	UpdatePriority: (serviceId, priority, who) => dispatch(ServiceAction.UpdatePriority(serviceId, priority, who)),
	ErrorCodeList: () => dispatch(ErrorCodeAction.GetList()),
	// BUG-225: _id 부재(빈 상세) 저장 차단 안내
	NotifyError: (message) => dispatch(AlertAction.ErrorMsg(message)),
});

export default connect(mapState, mapDispatch)(ServiceInfoView);
